import defaultApi from '@/utils/request';

export default {
  // 加載列表 // S70W2001 WEN902 教學助理評量(On-Line Evaluation of Teaching Assistants)-----
  S70W2001_LoadList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S70/S70W2001_LoadList',
      params,
    });
  },
  S70W2001_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S70/S70W2001_EditViewLoad',
      params,
    });
  },
  S70W2001_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S70/S70W2001_EditViewAction',
      data,
    });
  },
  S70W2001_SetOKAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S70/S70W2001_SetOKAction',
      data,
    });
  },
  // end 加載列表 // S70W2001 WEN902 教學助理評量(On-Line Evaluation of Teaching Assistants) -----

  // 加載列表 // S70W2002 WEN922 教師申請課程教學助理作業 -----
  S70W2002_LoadList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S70/S70W2002_LoadList',
      params,
    });
  },
  S70W2002_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S70/S70W2002_EditViewLoad',
      params,
    });
  },
  S70W2002_QueryStu(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S70/S70W2002_QueryStu',
      params,
    });
  },
  S70W2002_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S70/S70W2002_EditViewAction',
      data,
    });
  },
  S70W2002_Delete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S70/S70W2002_Delete',
      data,
    });
  },
  S70W2002_Send(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S70/S70W2002_Send',
      data,
    });
  },
  // end 加載列表 // S70W2002 WEN922 教師申請課程教學助理作業 -----
};
